import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  ScheduleAppointmentActionComponent,
  ScheduleAppointmentCalendarComponent,
  ScheduleAppointmentInformationComponent,
} from './components';
@Component({
  selector: 'app-schedule-appointment-modal',
  imports: [
    ScheduleAppointmentActionComponent,
    ScheduleAppointmentCalendarComponent,
    ScheduleAppointmentInformationComponent,
  ],
  templateUrl: './schedule-appointment-modal.component.html',
  styleUrls: ['./schedule-appointment-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleAppointmentModalComponent {}
